import { Button, Input, Spin, Tag, Select } from 'antd';
import { useEffect, useState } from "react";
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";
import {
    Card, CardBody,
    CardText,
    CardTitle,
    Table
} from 'reactstrap';
import { AllSPC } from "../../redux/actions/spc";
import { appUrl } from '../../redux/services/base';
import SPCService from "../../redux/services/spc";

let timer = null;

const SPCList = (props) => {
    const history = useHistory();
    const [selectedSPC, setSelectedSPC] = useState(null);
    const [loading, setLoading] = useState(false);
    const [graphModal, setGraphModal] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [runningParts, setRunningParts] = useState([]);

    useEffect(async () => {
        let _searchValue = searchValue;
        if (localStorage.getItem('spc_search_text')) {
            _searchValue = localStorage.getItem('spc_search_text');
            setSearchValue(localStorage.getItem('spc_search_text'));
        }
        setLoading(true);
        SPCService.allSPC("", {"is_running": 1, "page_size": 1000}).then(res=>{
            console.log("Running SPC > ", res);
            let parts = [];

            res?.results?.forEach(item => {
                if (
                    item.part_number &&
                    !parts.some(part => part.value === item.part_number)
                ) {
                    parts.push({
                        value: item.part_number,
                        label: item.part_number
                    });
                }
            });

            setRunningParts(parts);
        });
        await props.dispatch(AllSPC("", {"search": _searchValue}));
        setLoading(false);

        
    }, []);

    const previous = async () => {
        setLoading(true);
        await props.dispatch(AllSPC(props?.spc_list.previous, {}));
        setLoading(false);
    };

    const next = async () => {
        setLoading(true);
        await props.dispatch(AllSPC(props?.spc_list.next, {}));
        setLoading(false);
    };

    const search = async (event) => {
        if (timer != null) {
            window.clearTimeout(timer);
        }
        timer = window.setTimeout(async () => {

            let search = `${event.target.value}`;
            localStorage.setItem("spc_search_text", search);
            if (search != "") {
                setLoading(true);
                await props.dispatch(AllSPC("", {"search": search}));
                setLoading(false);
            }
            else {
                setLoading(true);
                await props.dispatch(AllSPC("", {"page": 1}));
                setLoading(false);
            }
        }, 500);
    };

    const changeRoute = (e, id, spc) => {
        e.preventDefault();
        history.push(`/graph/spc/${id}`, {
            data: spc
        });
    }

    const handleRunningPartsChange = async(partNumber)=>{
        setLoading(true);
        await props.dispatch(AllSPC("", {"page_size": "1000", "is_running": 1, "part_number": partNumber}));
        setLoading(false);
    }

    const [open, setOpen] = useState(false);

    return (
        <div className='site-drawer-render-in-current-wrapper'>
            <Card>
                <CardBody>
                    <CardTitle tag={"div"}>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <div>
                                <b style={{ fontSize: 20 }}>SPC List</b>
                            </div>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <div style={{marginRight: 10}}>
                                    <b>Running Parts</b>&nbsp;&nbsp;
                                    <Select allowClear={true} style={{minWidth: 160}} options={runningParts} onChange={handleRunningPartsChange} ></Select>
                                </div>
                                <div>
                                    <b>Search</b>&nbsp;&nbsp;
                                    <Input style={{ width: 250 }} type="text" allowClear value={searchValue} placeholder="Search..." onChange={(e) => setSearchValue(e.target.value)} onKeyUp={search} />
                                </div>
                            </div>
                        </div>
                    </CardTitle>
                    <CardText tag={"div"}>
                        <Spin spinning={loading}>
                            <Table responsive striped hover className="tbl-small">
                                <thead>
                                    <tr>
                                        <th>Cell No.</th>
                                        <th>Machine No.</th>
                                        <th>Part No.</th>
                                        <th>Operation No.</th>
                                        <th>Operation Name</th>
                                        <th>Characteristic</th>
                                        <th>Last Record Added At</th>
                                        <th>1 Measurement / (hrs)</th>
                                        <th>Measurement Stats</th>
                                        <th style={{ minWidth: 120, textAlign: "center" }}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        props?.spc_list?.results?.map((spc, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{spc.cell_number}</td>
                                                    <td>
                                                        {
                                                            spc.is_running ? (
                                                                <Tag title={spc.machine_down_reason_text} color={spc.is_machine_down ? "red" : "green"}>{spc.machine}</Tag>
                                                            ):(<span>{spc.machine}</span>)
                                                        }
                                                        
                                                    </td>
                                                    <td>{spc.part_number}</td>
                                                    <td>{spc.operation_number}</td>
                                                    <td>{spc.operation_name}</td>
                                                    <td>{spc.characteristic}</td>
                                                    <td>{spc.last_record_added_at && (new Date(spc.last_record_added_at).toLocaleString([], { hour12: true }))}</td>
                                                    <td style={{ textAlign: "center" }}>
                                                        {
                                                            spc.is_running ? (
                                                                <Tag color="blue">{spc.frequency}</Tag>
                                                            ) : (
                                                                <span>{spc.frequency}</span>
                                                            )
                                                        }
                                                    </td>
                                                    <td title={`${spc.shift} || Total down time: ${spc.total_down_time}`} style={{ textAlign: "center" }}>
                                                        {
                                                            spc.is_running ? (
                                                                <Tag
                                                                    color={
                                                                    (spc.total_spc_to_be_done - spc.total_spc_done) === 1
                                                                        ? "orange"
                                                                        : (spc.total_spc_to_be_done - spc.total_spc_done) > 1
                                                                        ? "red"
                                                                        : "green"
                                                                    }
                                                                    variant="outlined">
                                                                    {`${spc.total_spc_done} of ${spc.total_spc_to_be_done} ${
                                                                    spc.total_spc_done === 1 ? "is" : "are"
                                                                    } done`}
                                                                </Tag>
                                                            ):(
                                                                <span>-</span>
                                                            )
                                                        }
                                                    </td>

                                                    

                                                    <td>
                                                        <Button color="primary" variant="outlined" onClick={(e) => {
                                                            // setSelectedSPC(spc);
                                                            // setGraphModal(true);
                                                            changeRoute(e, spc.id, spc);
                                                        }}>
                                                            Graph
                                                        </Button>
                                                        &nbsp;
                                                        <Button color="warning" variant="outlined" href={`${appUrl}/api/v1/spc/${spc.id}/export/data?token=${props.token}`} target="_blank">
                                                            Download
                                                        </Button>


                                                        {/* <a href="#" onClick={(e) => changeRoute(e, spc.id)} >View Graph</a>
                                                    <br />
                                                    <a href={`${appUrl}/api/v1/spc/${spc.id}/export/data?token=${props.token}`} target="_blank">Export</a> */}
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </Table>
                        </Spin>
                    </CardText>
                    <div className="text-right">
                        <Button disabled={props?.spc_list.previous == null} onClick={previous} color='primary' >Prev</Button>
                        &nbsp;&nbsp;
                        <Button disabled={props?.spc_list.next == null} onClick={next} color='primary'>Next</Button>
                    </div>
                </CardBody>
            </Card>
        </div>
    );
};

function mapStateToProps(state) {
    const { spc_list } = state.spcList;
    const { auth } = state;
    const { token } = auth;
    return {
        spc_list,
        token
    }
}

export default connect(mapStateToProps)(SPCList);